import React from "react";
import SortAscendingSVG from "./SortAscendingSVG";
import { SortDirection } from "@/enums";
import { SortTableHeaderProps } from "@/models";

const SortTableHeader: React.FC<SortTableHeaderProps> = ({
  classes,
  text,
  colSpan = 1,
  onPress,
  sortStatus = SortDirection.NONE,
}) => {
  return (
    <th colSpan={colSpan} className={`${classes}`}>
      <button
        onClick={onPress}
        className={`d-flex flex-nowrap gap-2 align-items-center ${sortStatus === SortDirection.NONE ? 'no-sort' : ''}`}
      >
        {text}
        {sortStatus !== SortDirection.NONE && (
          <div
            style={{
              transform:
                sortStatus === SortDirection.DES ? "rotate(180deg)" : "none",
            }}
          >
            <SortAscendingSVG />
          </div>
        )}
      </button>
    </th>
  );
};

export default SortTableHeader;
